import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function normalizePhoneNumber(value?: string | null): string | undefined {
  if (!value) return undefined;

  const phoneNumber = parsePhoneNumberFromString(value);

  return phoneNumber?.isValid() ? phoneNumber.number : undefined;
}
